import gql from "graphql-tag";

export const deleteCollectionData = gql`
  query deleteCollectionData($input: DeleteCollectionInput!) {
    deleteCollectionData(input: $input) {
      presignedUrl
    }
  }
`;

export const deleteCollectionDataOptions = {
  name: "deleteCollectionData",
};
